import React, { useState, useRef, useEffect } from 'react';
import { Shape, Skeleton, Flex, styled } from '@teko/ds-desktop';
import { useFacebookSDK } from './useFacebook.es.js';

const FacebookComment = ({
  href,
  numPosts,
  width,
  appId,
  language,
  colorScheme,
  mobile,
  lazy
}) => {
  const { available, fb, xfbmlParse } = useFacebookSDK(appId, language);
  const [xfbmlRender, setRender] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!fb || !available)
      return;
    setRender(false);
    if (ref.current) {
      ref.current.style.height = "1px";
    }
    xfbmlParse();
    fb.Event.subscribe("xfbml.render", () => {
      setRender(true);
      if (ref.current) {
        ref.current.style.height = "auto";
      }
    });
    return () => {
      fb.Event.unsubscribe("xfbml.render", () => {
        setRender(false);
      });
    };
  }, [fb, href, numPosts, available]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, available ? /* @__PURE__ */ React.createElement(React.Fragment, null, !xfbmlRender && /* @__PURE__ */ React.createElement(FacebookCommentSkeleton, null), /* @__PURE__ */ React.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ React.createElement("div", {
    className: "fb-comments",
    "data-href": href,
    "data-numposts": numPosts,
    "data-width": width,
    "data-lazy": lazy,
    "data-mobile": mobile,
    "data-colorscheme": colorScheme
  }))) : null);
};
FacebookComment.displayName = "FacebookComment";
FacebookComment.defaultProps = {
  width: "100%",
  numPosts: 5,
  colorScheme: "light",
  mobile: "auto-detect",
  lazy: true
};
const FacebookCommentSkeleton = () => {
  return /* @__PURE__ */ React.createElement(Shape, {
    padding: "s8"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    height: "0.5rem",
    marginBottom: "s36",
    padding: ["s8", "s0"]
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    height: 1,
    marginBottom: "s24"
  }), /* @__PURE__ */ React.createElement(Flex, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    height: "4rem",
    width: "100%",
    marginBottom: "s16"
  })), /* @__PURE__ */ React.createElement(Flex, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ React.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))), /* @__PURE__ */ React.createElement(Flex, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ React.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))));
};
const Wrapper = styled.div`
  overflow: hidden;
`;

export { FacebookComment };
